module.exports = __webpack_public_path__ + "static/media/daskomLogo.10c86bf4.svg";